import { useSearchParams } from "react-router-dom";

/** The dashboard URL that opens `tab`, read back by `useDashboardActiveTab`. */
export const dashboardTabPath = (tab) => `/dashboard?active=${tab}`;

const useDashboardActiveTab = (defaultTab) => {
  const [searchParams] = useSearchParams();
  return searchParams.get("active") ?? defaultTab;
};

export default useDashboardActiveTab;
